<template>
        <div class="uk-container  uk-container-expand">
          <tab-bar></tab-bar>
             <form @submit.prevent="updateDate"> 
               <div class="uk-flex uk-flex-center ">
                 
                 <div class="uk-card uk-card-default my-5 py-4 my-3 px-3 uk-width-1-3">

                     <div class="uk-margin">
                        <label>Choisir date de début</label>
                        <div>
                          <input class="uk-input" type="date" v-model="date.debut">
                        </div>
                      </div>
                      <div class="uk-margin">
                        <label>Choisir date de fin</label>
                         <div>
                          <input class="uk-input" type="date" v-model="date.fin">
                        </div>
                      </div>
                       <div class="uk-margin">
                          <label>Choisir un livreur</label>
                        <select class="uk-select" v-model="date.livreur">
                            <option v-for="livreur in livreurs" :key="livreur.id" :value="livreur.id" >{{livreur.name}}</option>
                        </select>
                        </div>
                     <div class="d-flex justify-content-between align-items-start">
                       <button class="uk-button uk-button-primary uk-text-right" >Valider</button>
                        <router-link :to="{path: '/admin/livraison/savepoint' }">
                          <button class="uk-button uk-button-secondary uk-text-right" >Voir L'Historique des points</button>
                        </router-link>
                     </div>
                  </div>
               </div>
            </form>
        <div class="uk-card uk-card-default  uk-width-1-1@m mt-0 p-2" v-if="show == true">
            <h4 class="uk-text-center">Rapport par livreur </h4>
            <div class="uk-overflow-auto">
                <table class="uk-table uk-table-striped">
                  <thead>
                    <tr>
                          <th>N°</th>
                          <th>Nature de colis</th>
                          <th>Nom du client</th>
                          <th>Contact de la boutique</th>
                          <th>Contact du Destinataire</th>
                          <th>Itinéraire</th>
                          <th>Date & Heure : </th>
                          <th>Montant du Colis</th>
                          <th>Frais de livraison</th>

                      </tr>
                  </thead>
                  <tbody>
                      <tr v-for="(colis,item) in colisDuJour" :key="colis.id">
                          <td>{{item+1}}</td>
                          <td>{{colis.nature}}</td>
                          <td>{{colis.client_name}}</td>
                          <td>{{colis.client_phone}}</td>
                          <td>{{colis.dest_contact}}</td>
                          <td>{{colis.depart_address}} -> {{colis.dest_address}}</td>
                          <td>{{colis.created_at}}</td>
                          <td>{{colis.valeur}}</td>
                          <td>{{colis.montant}}</td>
                      </tr> 
                  </tbody>
              </table>
            </div>
            <div class="uk-flex uk-flex-center">
              <div class="my-3 uk-card uk-card-default uk-width-1-3">
                  <p class="my-3 uk-text-center">Point du Jour : <b>{{ total }}</b> FCFA</p>
              </div>
              
            </div>
        </div>
    </div>
</template>
<script>
import { db } from "../../main";
export default {
    data() {
    return {
      livreurs:[],
      date:{
        debut:"",
        fin:"",
        livreur:"",
      },
      commande: {
        statut: "",
        livreur_id: "",
      },
      Colis: {},
      // Livreur: {},
      colisDuJour: [],
      show:false,
    };
  },
  created(){
     db.ref("users")
      .orderByChild("role")
      .equalTo("1")
      .once("value")
      .then((dataSnapshot) => {
        const itemsArray = [];
        dataSnapshot.forEach((childSnapshot) => {
          const childData = childSnapshot.val();
          itemsArray.push({
            id: childData.id,
            role: childData.role,
            statusLivreur: childData.statusLivreur,
            name: childData.name,
            number: childData.number,
            email: childData.email,
          });
        });
        this.livreurs = itemsArray;
    });
  },
  methods:{
    sortArrays(livreurs) {
        return _.orderBy(livreurs, livreurs.name, 'asc');
    },
    updateDate(){
      this.colisDuJour = []
      let dbRef = db.ref("Colis Requetes")
    dbRef
      .get()
      .then((childSnapshot) => {
        const childData = childSnapshot.val();
        this.Colis = childData;
      })
      .catch((error) => {
        console.log(error);
      });
    db.ref("Colis Requetes")
      .orderByChild('livreur_id')
      .equalTo(this.date.livreur)
      .once("value")
      .then((dataSnapshot) => {
        dataSnapshot.forEach((childSnapshot) => {
          this.colisDuJour.push(childSnapshot.val())
        });
          this.show = true;
      });
    }
  },
  computed: {
    total() {
      let total = 0;
      this.colisDuJour.forEach((colis) => {
        total += colis.montant;
      });
      return total;
    },
  // total: function(){
  //   return this.colisDuJour.reduce(function(total, item){
  //     return total + item.montant; 
  //   },0);
  // },
}
}
</script>

<style>

.uk-card {
  width: 100%;
}

</style>